module.exports = __webpack_public_path__ + "static/zlotnik-hex-light-50cbcab0a6a78bfcd521af1b762f4cc2.png";